import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  CustomContainer,
  Form,
  connect,
  useDispatch,
} from "../../../atoms/DependencyHelper";
import EmploymentDetailsForm from "../../../atoms/newLineForms/creditCheckForms/employmentDetailsForm/EmploymentDetailsForm";
import EmploymentDetailsAddLineForm from "../../../atoms/newLineForms/creditCheckForms/employmentDetailsAddLineForm/EmploymentDetailsAddLineForm";
import EmploymentDetailsInfo from "../../../atoms/newLineForms/creditCheckDetails/employmentDetailsInfo/EmploymentDetailsInfo";
import EmploymentDetailsAddLineInfo from "../../../atoms/newLineForms/creditCheckDetails/employmentDetailsAddLineInfo/EmploymentDetailsAddLineInfo";
import CTAButton from "../../../atoms/CTAButton/CTAButton";
import {
  replaceDropdownKeys,
  imagePrefix,
  currencyRegex,
  getValueLabel,
  cellPhoneRegEx,
  numRegEx,
  africaCountryCode,
} from "../../../../utils/helperServices";
import { SET_CREDIT_CHECK_EMPLOYMENT_DATA } from "../../../../Redux/actionTypes/index";
import {
  EMP_CATEGORY_FKEY,
  EMP_CATEGORY_LKEY,
  OCCUPATION_TYPE_FKEY,
  OCCUPATION_TYPE_LKEY,
  OCCUPATIONS_FKEY,
  OCCUPATIONS_LKEY,
  SALARY_DAY_FKEY,
  SALARY_DAY_LKEY,
} from "../../../../config/constants";
import errorMessages from "../../../../config/errorMessages";
import Image from "../../../atoms/image/image";
import formStyles from "../CheckoutCreditCheck.module.scss";
import * as Analytics from "../../../../services/analyticsUtag";
import { journeyType } from "../../../../context/checkout-journey-context";
const analyticsTags = [
  "page_name",
  "page_channel",
  "page_master_tab",
  "visitor_login_status",
  "visitor_customer_id",
  "visitor_id_hash",
  "visitor_msisdn_hash",
  "visitor_subscription_type",
];

const EmploymentDetails = ({
  customerStatus,
  employmentDetailsData,
  loadLookupData,
  onFormSubmit,
  currentJourneyType,
  doCreditCheckDisable,
}) => {
  const [analytics, setAnalytics] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [displayEditMode, setDisplayEditMode] = useState(
    employmentDetailsData ? false : true
  );

  const [employmentTypes, setEmploymentTypes] = useState([]);
  const [employmentCategories, setEmploymentCategories] = useState([]);
  const [occupations, setOccupations] = useState([]);
  const [salaryDates, setSalaryDate] = useState([]);

  const cloneOfErrorMessages = JSON.parse(
    JSON.stringify(errorMessages.creditCheckout.errors.employment)
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (employmentDetailsData) {
      fieldValues.employmentDetails.employerName =
        employmentDetailsData.employerName;
      fieldValues.employmentDetails.employmentType =
        employmentDetailsData.employmentType;
      fieldValues.employmentDetails.employmentCategory =
        employmentDetailsData.employmentCategory;
      fieldValues.employmentDetails.occupation =
        employmentDetailsData.occupation;
      fieldValues.employmentDetails.salaryDate =
        employmentDetailsData.salaryDate;
      fieldValues.employmentDetails.grossMonthlySalary =
        employmentDetailsData.grossMonthlySalary;
      fieldValues.employmentDetails.employerNumber =
        employmentDetailsData.employerNumber ? employmentDetailsData.employerNumber 
        : "";  

      errorStatus.employmentDetails = checkFormError("employmentDetails");

      if (errorStatus.employmentDetails) {
        setSubmitDisabled(true);
      } else {
        setSubmitDisabled(false);
      }

      setState({
        ...state,
        fieldValues,
        errorStatus,
      });
    }
  }, [employmentDetailsData]);

  const addLineDataValidation = {
    validationsOn: {
      employmentDetails: true,
    },
    errorStatus: {
      employmentDetails: true,
    },
    validations: {
      employmentDetails: {
        employerName: false,
        employmentType: false,
        employmentCategory: false,
        occupation: false,
        salaryDate: false,
        grossMonthlySalary: true,
      },
    },
    fieldErrors: {
      employmentDetails: {
        employerName: false,
        employmentType: false,
        employmentCategory: false,
        occupation: false,
        salaryDate: false,
        grossMonthlySalary: false,
      },
      fail: false,
    },
    fieldValues: {
      employmentDetails: {
        employerName: "",
        employmentType: "",
        employmentCategory: "",
        occupation: "",
        salaryDate: "",
        grossMonthlySalary: "",
      },
    },
    fieldErrorsMessage: cloneOfErrorMessages,
  };

  const [state, setState] = useState(
    currentJourneyType !== journeyType.addLine
      ? {
          validationsOn: {
            employmentDetails: true,
          },
          errorStatus: {
            employmentDetails: true,
          },
          validations: {
            employmentDetails: {
              employerName: true,
              employerNumber: true,
              employmentType: true,
              employmentCategory: true,
              occupation: true,
              salaryDate: true,
              grossMonthlySalary: true,
            },
          },
          fieldErrors: {
            employmentDetails: {
              employerName: false,
              employerNumber: false,
              employmentType: false,
              employmentCategory: false,
              occupation: false,
              salaryDate: false,
              grossMonthlySalary: false,
            },
            fail: false,
          },
          fieldValues: {
            employmentDetails: {
              employerName: "",
              employerNumber: "",
              employmentType: "",
              employmentCategory: "",
              occupation: "",
              salaryDate: "",
              grossMonthlySalary: "",
            },
          },
          fieldErrorsMessage: cloneOfErrorMessages,
        }
      : addLineDataValidation
  );
  const {
    validationsOn,
    errorStatus,
    validations,
    fieldErrors,
    fieldValues,
    fieldErrorsMessage,
  } = state;

  useEffect(() => {
    setEmploymentTypes(
      replaceDropdownKeys(
        loadLookupData?.EMPLOYMENT_CATEGORIES,
        EMP_CATEGORY_FKEY,
        EMP_CATEGORY_LKEY
      )
    );
    setEmploymentCategories(
      replaceDropdownKeys(
        loadLookupData?.OCCUPATION_TYPE,
        OCCUPATION_TYPE_FKEY,
        OCCUPATION_TYPE_LKEY
      )
    );
    setOccupations(
      replaceDropdownKeys(
        loadLookupData?.OCCUPATIONS,
        OCCUPATIONS_FKEY,
        OCCUPATIONS_LKEY,
        "occupations"
      )
    );
    setSalaryDate(
      replaceDropdownKeys(
        loadLookupData?.SALARY_DAY,
        SALARY_DAY_FKEY,
        SALARY_DAY_LKEY
      )
    );
  }, []);

  /**
   * Form input field change event handler
   *
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onChange event
   */
  const handleChange = async (event, val, form) => {
    event.persist();
    if (!analytics) {
      Analytics.link({
        ...Analytics.getUtagData([
          "page_name",
          "visitor_login_status",
          "visitor_id_hash",
          "visitor_msisdn_hash",
          "visitor_subscription_type",
        ]),
        page_form_event: "start",
        page_form_name: `checkout: credit check: ${customerStatus}: work details`,
      });
      setAnalytics(true);
    }
    await updateFieldValues(event, val, form);
  };

  /**
   * Form input field blur event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onBlur event
   */
  const handleBlur = async (event, val, form) => {
    event.persist();
    const name = event.target.name;
    const value = val ? val : event.target.value;

    await fieldValidationCheck(event, value, form);

    errorStatus[form] = await checkFormError(form);
    setState({
      ...state,
      errorStatus,
      validations,
    });

    if (fieldErrors.fail) {
      setSubmitDisabled(true);

      let errMsg = fieldErrorsMessage[form][name];
      inlineAnalytics(errMsg);
    } else {
      checkErrorStatus();
    }
  };

  /**
   * update input field values
   *
   * @usage Set the state of fieldValues
   */
  const updateFieldValues = async (event, val, form) => {
    const name = event.target.name;
    const value = val ? val : event.target.value;

    if (name === "grossMonthlySalary") {
      fieldValues[form][name] = formatCurrency(value, event);
    } else {
      fieldValues[form][name] = value;
    }
    if (name === "employmentCategory") {
      if (value === "PEN") {
        validations[form].employerNumber = false;
        fieldValues[form].employerNumber = "";
        fieldErrors.fail = false;
      } else {
        validations[form].employerNumber = true;
        fieldErrors.fail = true;
      }
    }
    setState({
      ...state,
      fieldValues,
      validations,
      errorStatus,
      fieldErrors,
    });
  };

  /**
   * Dropdown field reset handler
   *
   * @usage Remove the selected values
   */
  const handleReset = async (name, form) => {
    switch (name) {
      case "employmentType":
        fieldValues[form].employmentType = "";
        break;
      case "employmentCategory":
        fieldValues[form].employmentCategory = "";
        break;
      case "occupation":
        fieldValues[form].occupation = "";
        break;
      case "salaryDate":
        fieldValues[form].salaryDate = "";
        break;
    }
    errorStatus[form] = await checkFormError(form);
    setState({
      ...state,
      fieldValues,
      errorStatus,
    });

    if (errorStatus[form]) {
      setSubmitDisabled(true);
    } else {
      checkErrorStatus();
    }
  };

  /**
   * Check form error status
   *
   * @usage check if form error status is true or false
   * @usage Enable or disable form submit button
   */
  function checkErrorStatus() {
    var errValues = Object.values(state.errorStatus);
    for (const err of errValues) {
      if (err) {
        if (currentJourneyType != journeyType.addLine) {
          setSubmitDisabled(true);
          return;
        }
      }
    }
    setSubmitDisabled(false);
  }

  const reStructuredSalary = (salary) => {
    let amount = salary.replace(/\n|\R/g, "");
    return amount.replace(/,/g, "").toString();
  };

  /**
   * Check input field validation
   *
   * @usage Set the state of form validations, fieldValues, fieldErrors, fieldErrorsMessage
   */
  const fieldValidationCheck = async (event, val, form) => {
    const name = event.target.name;
    const value = val ? val : event.target.value;
    switch (name) {
      case "employerName":
        if (state.validationsOn[form] && state.validations[form].employerName) {
          if (value?.length === 0) {
            fieldErrors[form].employerName = true;
            fieldErrorsMessage[form].employerName =
              state.fieldErrorsMessage.employmentDetails.employerName;
          } else {
            fieldErrors[form].employerName = false;
          }
          fieldErrors.fail = fieldErrors[form].employerName;
        } else {
          fieldErrors[form].employerName = false;
        }
        break;

      case "employerNumber":
        if (
          state.validationsOn[form] &&
          state.validations[form].employerNumber
        ) {
          if (value?.length > 0) {
            if (!numRegEx.test(value)) {
              fieldErrors[form].employerNumber = true;
              fieldErrorsMessage[form].employerNumber =
                errorMessages.creditCheckout.employmentDetails.employerNumber.onlyNumber;
            } else if (!cellPhoneRegEx.test(value)) {
              fieldErrors[form].employerNumber = true;
              fieldErrorsMessage[form].employerNumber =
                errorMessages.creditCheckout.employmentDetails.employerNumber.startWith;
            } else if (africaCountryCode(value) && value.length < 11) {
              fieldErrors[form].employerNumber = true;
              fieldErrorsMessage[form].employerNumber =
                state.fieldErrorsMessage.employmentDetails.employerNumber;
            } else if (value?.length < 10) {
              fieldErrors[form].employerNumber = true;
              fieldErrorsMessage[form].employerNumber =
                state.fieldErrorsMessage.employmentDetails.employerNumber;
            } else {
              fieldErrors[form].employerNumber = false;
            }
          } else {
            fieldErrors[form].employerNumber = true;
            fieldErrorsMessage[form].employerNumber =
              cloneOfErrorMessages.employmentDetails.employerNumber;
          }
          fieldErrors.fail = fieldErrors[form].employerNumber;
        } else {
          fieldErrors[form].employerNumber = false;
        }
        break;

      case "employmentType":
        if (
          state.validationsOn[form] &&
          state.validations[form].employmentType
        ) {
          if (value?.length === 0) {
            fieldErrors[form].employmentType = true;
            fieldErrorsMessage[form].employmentType =
              state.fieldErrorsMessage.employmentDetails.employmentType;
          } else {
            fieldErrors[form].employmentType = false;
          }
          fieldErrors.fail = fieldErrors[form].employmentType;
        } else {
          fieldErrors[form].employmentType = false;
        }
        break;

      case "employmentCategory":
        if (
          state.validationsOn[form] &&
          state.validations[form].employmentCategory
        ) {
          if (value?.length === 0) {
            fieldErrors[form].employmentCategory = true;
            fieldErrorsMessage[form].employmentCategory =
              state.fieldErrorsMessage.employmentDetails.employmentCategory;
          } else {
            fieldErrors[form].employmentCategory = false;
          }
          fieldErrors.fail = fieldErrors[form].employmentCategory;
        } else {
          fieldErrors[form].employmentCategory = false;
        }
        break;

      case "occupation":
        if (state.validationsOn[form] && state.validations[form].occupation) {
          if (value?.length === 0) {
            fieldErrors[form].occupation = true;
            fieldErrorsMessage[form].occupation =
              state.fieldErrorsMessage.employmentDetails.occupation;
          } else {
            fieldErrors[form].occupation = false;
          }
          fieldErrors.fail = fieldErrors[form].occupation;
        } else {
          fieldErrors[form].occupation = false;
        }
        break;

      case "salaryDate":
        if (state.validationsOn[form] && state.validations[form].salaryDate) {
          if (value?.length === 0) {
            fieldErrors[form].salaryDate = true;
            fieldErrorsMessage[form].salaryDate =
              state.fieldErrorsMessage.employmentDetails.salaryDate;
          } else {
            fieldErrors[form].salaryDate = false;
          }
          fieldErrors.fail = fieldErrors[form].salaryDate;
        } else {
          fieldErrors[form].salaryDate = false;
        }
        break;

      case "grossMonthlySalary":
        if (
          state.validationsOn[form] &&
          state.validations[form].grossMonthlySalary
        ) {
          if (value?.length > 0) {
            if (
              !currencyRegex.test(
                reStructuredSalary(formatCurrency(value, event))
              )
            ) {
              fieldErrors[form].grossMonthlySalary = true;
              fieldErrorsMessage[form].grossMonthlySalary =
                currentJourneyType !== journeyType.addLine
                  ? errorMessages.creditCheckout.employmentDetails
                      .grossMonthlySalary.onlyValid
                  : errorMessages.creditCheckout.employmentDetails
                      .grossMonthlySalary.onlyZero;
            } else {
              fieldErrors[form].grossMonthlySalary = false;
            }
          } else {
            fieldErrors[form].grossMonthlySalary = true;
            fieldErrorsMessage[form].grossMonthlySalary =
              errorMessages.creditCheckout.errors.employment.employmentDetails.grossMonthlySalary;
          }
          fieldErrors.fail = fieldErrors[form].grossMonthlySalary;
        } else {
          fieldErrors[form].grossMonthlySalary = false;
        }
        break;
    }

    setState({
      ...state,
      fieldErrors,
      fieldValues,
      fieldErrorsMessage,
    });
  };

  function formatNumber(n) {
    // format number 1234567 to 1,234,567
    return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  /**
   * This function is used to format the enetered number in the south african currency
   *
   * @call onChnage event
   */
  function formatCurrency(input, event) {
    // don't validate empty input
    if (input === "") {
      return;
    }
    if (input.indexOf(".") >= 0) {
      var decimal_pos = input.indexOf(".");
      var left_side = input.substring(0, decimal_pos);
      var right_side = input.substring(decimal_pos);
      left_side = formatNumber(left_side);
      right_side = formatNumber(right_side);

      // Limit decimal to only 2 digits
      right_side = right_side.substring(0, 2);
      // appends R to value, validates decimal side
      input = "R" + left_side;
    } else {
      input = formatNumber(input);
      input = "R" + input;
    }
    return input;
  }

  /**
   * Set the analytics(link)
   *
   * @call when there is any form field error occured
   */
  const inlineAnalytics = (message) => {
    Analytics.link({
      ...Analytics.getUtagData(analyticsTags),
      page_form_event: "error",
      page_errors: message,
      page_form_name: `checkout: credit check: ${customerStatus}: work details`,
      page_error_type: "form",
    });
  };

  /**
   * Set the on page edit
   *
   * @call on edit event
   */
  const setAnalyticsOnPageEdit = () => {
    Analytics.link({
      ...Analytics.getUtagData(analyticsTags),
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: `checkout: credit check: ${customerStatus}: edit work details`,
    });
  };

  /**
   * Check entire form error
   *
   * @usage check if any form field value is empty or not
   * @return true/false
   */
  function checkFormError(form) {
    var values = state.fieldValues[form];
    var errors = state.fieldErrors[form];
    var entries = Object.entries(state.validations[form]);

    if (state.validationsOn[form]) {
      for (const [key, value] of entries) {
        if ((values[key] == "" && value) || errors[key]) {
          return true;
        }
      }
      return false;
    } else {
      return false;
    }
  }

  /**
   * Set the on page submit
   *
   * @call on next button click
   */
  const setAnalyticsOnNextButton = () => {
    Analytics.link({
      ...Analytics.getUtagData(analyticsTags),
      link_type: "o",
      link_name: `checkout: credit check: ${customerStatus}: work details: next`,
    });
  };

  /**
   * Form submit handler
   *
   * @usage call submitForm funtion when there is no error
   * @call onSubmit event
   */
  const handleSubmit = (event) => {
    event.preventDefault();
    event.persist();
    setAnalyticsOnNextButton();

    if (!state.errorStatus["employmentDetails"]) {
      submitForm();
    }
  };

  /**
   * Form submit handler
   *
   * @usage call submitForm funtion when there is no error
   * @call onSubmit event
   */
  const handleEmploymentSubmit = (event) => {
    event.preventDefault();
    event.persist();

    if (!state.errorStatus["employmentDetails"]["grossMonthlySalary"]) {
      submitForm();
      Analytics.link({
        ...Analytics.getUtagData([
          "page_name",
          "visitor_login_status",
          "visitor_id_hash",
          "visitor_msisdn_hash",
          "visitor_subscription_type",
        ]),
        page_form_event: "success",
        page_form_name: `checkout: credit check: ${customerStatus}: work details`,
      });
    }
  };

  /**
   *
   * @usage submit the form with request payload
   */
  const submitForm = async () => {
    const empCategory = getValueLabel(
      state.fieldValues["employmentDetails"]["employmentCategory"],
      employmentCategories
    );
    const empIndustry = getValueLabel(
      state.fieldValues["employmentDetails"]["occupation"],
      occupations
    );
    dispatch({
      type: SET_CREDIT_CHECK_EMPLOYMENT_DATA,
      payload: {
        ...state.fieldValues["employmentDetails"],
        empCategory: empCategory,
        empIndustry: empIndustry,
      },
    });
    onFormSubmit(true);
    setDisplayEditMode(false);
    doCreditCheckDisable("employmentDetails", false);

    Analytics.link({
      ...Analytics.getUtagData(analyticsTags),
      page_form_event: "success",
      page_form_name: `checkout: credit check: ${customerStatus}: work details`,
    });
  };

  /**
   *
   * @usage open form in edit mode and set analytics on click of edit button
   */
  const clickOnEditButton = () => {
    setDisplayEditMode(true);
    doCreditCheckDisable("employmentDetails", true);
    setAnalyticsOnPageEdit();
  };

  return (
    <>
      <CustomContainer
        className={`${formStyles["container"]}`}
        id="work-details"
      >
        <CustomContainer className={formStyles["form-heading"]}>
          {displayEditMode ? (
            <Image
              img_path={`${imagePrefix}/assets/images/icon-career.svg`}
              img_alt="section"
              className={formStyles["section-icon"]}
            />
          ) : (
            <Image
              img_path={`${imagePrefix}/assets/images/success-circle_small.svg`}
              img_alt="success"
              className={formStyles["section-success-icon"]}
            />
          )}
          {currentJourneyType != journeyType.addLine
            ? "Work details"
            : "Salary Details"}
          {displayEditMode ? (
            <CustomContainer className={formStyles["section-numbers"]}>
              {currentJourneyType != journeyType.addLine
                ? "Section 3 of 7"
                : "Section 2 of 5"}
            </CustomContainer>
          ) : (
            <CustomContainer className={formStyles["section-numbers"]}>
              <a onClick={() => clickOnEditButton()}>
                <Image
                  img_path={`${imagePrefix}/assets/images/blog.svg`}
                  img_alt="edit"
                />
                <span>Edit details</span>
              </a>
            </CustomContainer>
          )}
        </CustomContainer>
        <hr></hr>
        {currentJourneyType == journeyType.newLine &&
          (!displayEditMode ? (
            <EmploymentDetailsInfo
              data={employmentDetailsData}
              employmentTypes={employmentTypes}
              employmentCategories={employmentCategories}
              occupations={occupations}
            />
          ) : (
            <Form
              noValidate
              id="checkout-credit-check-employment-form"
              onSubmit={handleSubmit}
            >
              <EmploymentDetailsForm
                formName={"employmentDetails"}
                fieldValues={state.fieldValues["employmentDetails"]}
                fieldErrors={state.fieldErrors["employmentDetails"]}
                fieldErrorsMessage={
                  state.fieldErrorsMessage["employmentDetails"]
                }
                onChangeHandler={handleChange}
                onBlurHandler={handleBlur}
                onResetHandler={handleReset}
                employmentTypes={employmentTypes}
                employmentCategories={employmentCategories}
                occupations={occupations}
                salaryDates={salaryDates}
              />
              <CustomContainer className={formStyles["button-wrapper"]}>
                <CTAButton
                  type="submit"
                  variant="solid grey"
                  disabled={submitDisabled}
                  className={formStyles["button"]}
                  id="checkout-credit-check-employment-form-submit"
                >
                  Next
                </CTAButton>
              </CustomContainer>
            </Form>
          ))}
        {currentJourneyType == journeyType.addLine &&
          (!displayEditMode ? (
            <EmploymentDetailsAddLineInfo data={employmentDetailsData} />
          ) : (
            <Form
              noValidate
              id="checkout-credit-check-employment-form"
              onSubmit={handleEmploymentSubmit}
            >
              <EmploymentDetailsAddLineForm
                formName={"employmentDetails"}
                fieldValues={state.fieldValues["employmentDetails"]}
                fieldErrors={state.fieldErrors["employmentDetails"]}
                fieldErrorsMessage={
                  state.fieldErrorsMessage["employmentDetails"]
                }
                onChangeHandler={handleChange}
                onBlurHandler={handleBlur}
              />
              <CustomContainer className={formStyles["button-wrapper"]}>
                <CTAButton
                  type="submit"
                  variant="solid grey"
                  disabled={submitDisabled}
                  className={formStyles["button"]}
                  id="checkout-credit-check-employment-form-submit"
                >
                  Next
                </CTAButton>
              </CustomContainer>
            </Form>
          ))}
      </CustomContainer>
    </>
  );
};

EmploymentDetails.propTypes = {
  customerStatus: PropTypes.string,
  onFormSubmit: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    employmentDetailsData: state.creditCheckDetails.employmentDetails,
    loadLookupData: state.checkoutDetails.lookupDetails,
  };
};

export default connect(mapStateToProps)(EmploymentDetails);
